// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IntakePatientIntakeDefaultResponse {
    static getAttributeTypeMap() {
        return IntakePatientIntakeDefaultResponse.attributeTypeMap;
    }
}
IntakePatientIntakeDefaultResponse.discriminator = undefined;
IntakePatientIntakeDefaultResponse.additionalProperties = false;
IntakePatientIntakeDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "IntakePatientIntakeDefaultResponseData"
    },
];
//# sourceMappingURL=intakePatientIntakeDefaultResponse.js.map